module.exports = __webpack_public_path__ + "img/mobile-phone.6584cf34.svg";